/* eslint-disable react/prop-types */ // TODO: add props
import style from './SectionHeading.scss';

export default ({ children }) => (
  <h3 className={style.SectionHeading}>{children}</h3>
);
